import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { AsteriskModule } from '@salesrun/ngx-asterisk';
import { NoAutocompleteModule } from '@salesrun/ngx-no-autocomplete';
import { PasswordSetupModule } from '@salesrun/ngx-password-setup';
import { TimezoneModule } from '@salesrun/ngx-timezone';
import { SwiperModule } from 'swiper/angular';
import { ExpiredComponent } from './expired/expired.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { LoginService } from './login.service';
import { PasswordPageComponent } from './password-page/password-page.component';
import { PasswordResetPageComponent } from './password-reset-page/password-reset-page.component';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        SwiperModule,
        FlexLayoutModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDialogModule,
        MatSnackBarModule,
        AsteriskModule,
        NoAutocompleteModule,
        TimezoneModule,
        PasswordSetupModule,
    ],
    declarations: [
        LoginPageComponent,
        PasswordPageComponent,
        PasswordResetPageComponent,
        ExpiredComponent,
    ],
    providers: [
        LoginService,
    ],
})

export class LoginModule { }
